<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="15.068" height="19.719" viewBox="0 0 15.068 19.719">
        <g transform="translate(0.75 0.75)" class="fill-current">
            <path d="M8.629,64.794l3.464,3.853h3.975V59.66H2.5v8.987H7.332" transform="translate(-2.5 -50.429)" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1"></path>
            <circle cx="3.577" cy="3.577" r="3.577" transform="translate(3.207)" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1"></circle>
        </g>
    </svg>
</template>